function showUp(dom){
    gsap.from(dom, {
        y: '2rem', opacity: 0, ease: 'none', duration: 0.5,
        scrollTrigger: {
            trigger: dom,
            start: 'top bottom-=20%',
            end: '+=0',
            //toggleActions: 'play none none reverse',
        }
    })
}

function onViewLoad(className) {
    const elements = $(className).get();
    
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                const video = entry.target
                video.src = video.dataset.src
                video.load()
                observer.unobserve(video);
            }
        });
    }, { threshold:0,rootMargin: '500px', });
    
    elements.forEach(el => observer.observe(el));
}
if(wFlag){
    // onViewLoad('.lazy_video_p')
}else{
    onViewLoad('.lazy_video_m')
}
$(()=>{
    setTimeout(() => {
        $('.box1_title').css({transform:'translateY(0)',opacity:1})
    }, 300);

    showUp('.box2_title')
    showUp('.box4_title')
    showUp('.box7_text')

    //box7
    if(wFlag){
        var $video = $('.box7_video');
        ScrollTrigger.create({
            trigger:'.box7',
            start:'top center+=10%',
            end:'+=100%',
            scrub:true,
            onUpdate: function (self) {
                //console.log($video[0].duration)
                $video[0].currentTime = self.progress * 3.56;
                $('.box7_title').toggleClass('showUp',self.progress>0.8)
            },
            animation: gsap.timeline()
                .from('.box7_video', { opacity:0 })
                .to({}, { duration:0.5 })
        })

        ScrollTrigger.create({
            trigger:'.box7',
            start:'top top+=2%',
            end:'+=80%',
            pin:true,
            anticipatePin: 1
        })
    }else{
        showUp('.box7_title')
    }

    //box5
    ScrollTrigger.create({
        trigger: '.box5',
        start: wFlag?'top top+=3%':'top top+=5%',
        end: '+=100%',
        scrub:1,
        pin:true,
        animation: gsap.timeline()
            .from('.box5_3x', { x:wFlag?'58%':'88%',scale:wFlag?1.2:1.5,y:wFlag?0:'-85%' })
            .from('.box5_img,.box5_info div,.box5_title', { opacity:0 })
            .to('.box5_3x,.box5_info', { opacity:0 })
            .from('.box5_text', { opacity:0,y:'2rem' },'-=30%')
            .to('.box5_img img:last-child', { opacity:1 },'<')
            .to('.box5_img img:first-child', { opacity:0 },'<')
            .to({}, { duration:0.2 })
    })

    //box8
    showUp('.box8_title')

    var nexlimN1 = 100,ng_flag=true,flag_ng;
    function startNG(){
        clearInterval(flag_ng); // 防止重复开启多个定时器
        flag_ng =  setInterval(num,10)
    }
    function num(){
        nexlimN1++;
        if (nexlimN1 >= 200) {
            nexlimN1 = 200;
            clearInterval(flag_ng);
        }
    
        $(`.box8_item div:nth-child(1) p c`).text(`${nexlimN1}%`);
        $(`.box8_item div:nth-child(2) p c`).text(`${nexlimN1-80}ML`);
        $(`.box8_item div:nth-child(3) p c`).text(`${nexlimN1-100}%`);
    }

    ScrollTrigger.create({
        trigger:'.box8', 
        start:'top center',
        end:'+=0%',
        toggleActions:'play none none reverse',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            if(index>10){
                // 执行一次
                if(ng_flag){
                    startNG()
                    ng_flag=false;
                }
            }
            if(index<2){
                // 重置
                ng_flag=true,nexlimN1 = 100
            }
        }
    })

    //box9
    showUp('.box9_item div:nth-child(1) p')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box9',
            start:'top+=20% top+=6%',
            end:'+=0%',
            toggleActions: 'play none none reverse',
            animation:gsap.timeline()
                .to('.box9_item div:nth-child(1) img',{opacity:1})
                .to('.box9_item div:nth-child(2) p:nth-child(2)',{opacity:1},'<')
        })

        ScrollTrigger.create({
            trigger:'.box9',
            start:'top top+=6%',
            end:'+=40%',
            pin:true,
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box9',
            start:'top top+=6%',
            end:'+=55%',
            scrub:1,
            onUpdate: function (self) {
                let index = Math.floor(self.progress * 20);
                $('.box9_items .box9_item:nth-child(1) div:nth-child(1) img,.box9_items .box9_item:nth-child(1) div:nth-child(2) p:nth-child(2)').toggleClass('opacity1',index>2)
                $('.box9_items .box9_item:nth-child(2) div:nth-child(1) img,.box9_items .box9_item:nth-child(2) div:nth-child(2) p:nth-child(2)').toggleClass('opacity1',index>18)
            }
        })
    }

    //box6
    showUp('.box6_title')
    ScrollTrigger.create({
        trigger: '.box6',
        start:'top top+=6%',
        end: '+=40%',
        pin:true,
        anticipatePin: 1,
        onUpdate: function (self) {
            let index = Math.floor(self.progress * 10);
            $('.box6_left div:last-child').toggleClass('box6Active',index>4)
        }
    })

    //box11
    showUp('.box11_title')
    ScrollTrigger.create({
        trigger:'.box11_img',
        start:'top center',
        end:'+=0%',
        //markers:true,
        toggleActions:'play none none reverse',
        animation:gsap.timeline().from('.box11_img img:nth-child(2)',{scale:0,duration:1})
    })

    showUp('.box12_title')

    //box13
    showUp('.box13_title')

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box13_items',
            start:'top bottom-=30%',
            end:'+=20%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .from('.box13_items .box13_item:nth-child(1)',{x:'106%',opacity:0})
                .from('.box13_items .box13_item:nth-child(3)',{x:'-106%',opacity:0},'<')
        })
    }else{
        $('.box13_nav div').click(function(){
            var index = $(this).index();
            $('.box13_nav div').removeClass('box13_active')
            $(this).addClass('box13_active')
            $('.box13_items .box13_item').hide()
            $('.box13_items .box13_item').eq(index).show()
        })
    }

    //box17
    showUp('.box17_title')

    //box10
    showUp('.box10_title')
    new Swiper('.box10Swiper', {
        //autoplay: true,
        pagination: {
            el: '.box10Swiper-pagination',
            clickable:true
        },
    })

    //boxSpecs_btn
    $('.bs_btn').click(function(){
        window.scrollTo(0,0)
    })

    $('.pnr_buy').click(function(){ 
       window.open('https://store.oxva.com/products/oxva-nexlim-cartridge-unitech-3-0'); 
    })

    $('.pnr_spec').click(function(){
        $('.Mpn_popup').css({height:'0'})
        document.querySelector(".box10").scrollIntoView({block: "start",behavior: "smooth"});
    })

    $('.pnr_over2').click(function(){
        $('.Mpn_popup').css({height:'0'})
        window.scrollTo(0,0)
    })
})